import { useCallback } from 'react';

import { useNonRevalidatingFetcher } from '~/hooks/useNonRevalidatingFetcher';
import type { CancelGroupSubscriptionActionData } from '~/routes/__actions/cancel_group_subscription';

export type CancelSubscriptionResult = {
  ok: boolean;
  error: string | null;
};

export type UseCancelSubscriptionResult = {
  cancelSubscription: (groupId: string) => Promise<CancelSubscriptionResult>;
};

export function useCancelSubscription(): UseCancelSubscriptionResult {
  const cancelFetcher = useNonRevalidatingFetcher<() => Promise<CancelGroupSubscriptionActionData>>();

  const cancelSubscription = useCallback(
    async (groupId: string): Promise<CancelSubscriptionResult> => {
      const submitResult = await cancelFetcher.submit(JSON.stringify({ group_subscription_id: groupId }), {
        method: 'post',
        action: '/cancel_group_subscription',
        encType: 'application/json',
      });
      const error = submitResult.data?.error ?? (submitResult.ok ? null : 'Failed to cancel subscription');
      return { ok: submitResult.ok && !error, error };
    },
    [cancelFetcher.submit],
  );

  return { cancelSubscription };
}
